import React, { useState } from "react";
import { motion } from "framer-motion";
import Modal from "react-modal";
import { login, register, forgotPassword, loginWithGoogle } from "../../api/Auth.api"; // Import API functions
import { saveToken } from "../../utils/localStorage";
import "./style.scss";
import gmailIcon from '../../assets/users/images/getstarted/gmail.png';

const GetStartedButton = ({ onLoginSuccess, onCloseHamburger }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isRegister, setIsRegister] = useState(false); // Toggle between Register and Login
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState(""); // Only used for registration
  const [errorMessage, setErrorMessage] = useState(""); // To display error messages
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
    setErrorMessage(""); // Clear error message when modal is toggled
    if (onCloseHamburger) {
      onCloseHamburger(); // Close the hamburger menu if it's open
    }
  };

  const switchMode = () => {
    setIsRegister(!isRegister);
    setErrorMessage(""); // Clear error message when switching modes
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isRegister) {
        // Call the register API
        const response = await register(fullName, email, password);
        console.log("Registration successful:", response);
        alert("Registration successful! You can now log in.");
        setIsRegister(false); // Switch to login mode after successful registration
      } else {
        // Call the login API
        const response = await login(email, password);
        console.log("Full login response.data:", response);
        alert("Login successful!");
        toggleModal(); // Close the modal after successful login
        const token = response.token;
        saveToken(token);

        // Call the onLoginSuccess function to fetch and save user info
        if (onLoginSuccess) {
          await onLoginSuccess(response); // Pass the login response to handleLoginSuccess
        }
      }
    } catch (error) {
      console.error("Authentication error:", error);
      setErrorMessage(
        error?.response?.data?.message || "An error occurred. Please try again."
      );
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    try {
      await forgotPassword(forgotEmail);
      setForgotMessage("Password reset instructions sent to your email.");
    } catch (error) {
      setForgotMessage(
        error?.response?.data?.message || "Failed to send reset email."
      );
    }
  };

  return (
    <>
      {/* Get Started Button with animation */}
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="get-started-btn"
        onClick={toggleModal}
      >
        Get Started Now
      </motion.button>

      {/* Modal for Login/Register */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={toggleModal}
        className="custom-modal"
        overlayClassName="custom-overlay"
      >
        {!showForgot ? (
          <>
            <h2>{isRegister ? "Register" : "Login"}</h2>
            <form onSubmit={handleSubmit}>
              {isRegister && (
                <motion.input
                  type="text"
                  placeholder="Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                  whileFocus={{ scale: 1.02 }}
                />
              )}
              <motion.input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                whileFocus={{ scale: 1.02 }}
              />
              <motion.input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                whileFocus={{ scale: 1.02 }}
              />
              {errorMessage && <p className="error-message">{errorMessage}</p>}
              <motion.button
                type="submit"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="login-btn"
              >
                {isRegister ? "Register" : "Login"}
              </motion.button>
            </form>
            {/* Forgot password button */}
{!isRegister && (
  <>
    <div style={{ marginTop: '15px', textAlign: 'center', color: '#666' }}>
      Or sign in with
    </div>
    <div style={{ textAlign: 'center', marginTop: '10px' }}>
      <img
        src={gmailIcon}
        alt="Gmail"
        style={{ width: '30px', height: '30px', cursor: 'pointer' }}
        onClick={loginWithGoogle}
      />
    </div>
  </>
)}

<button
  className="forgot-password-btn"
  style={{ marginTop: "10px", background: "none", border: "none", color: "#007bff", cursor: "pointer" }}
  onClick={() => {
    setShowForgot(true);
    setForgotMessage("");
    setForgotEmail(email);
  }}
  type="button"
>
  Forgot password?
</button>
            {/* ...existing code for Gmail and switch mode... */}
            <p className="switch-mode" onClick={switchMode}>
              {isRegister
                ? "Already have an account? Login"
                : "Don't have an account? Register"}
            </p>
            <button className="close-btn" onClick={toggleModal}>
              Close
            </button>
          </>
        ) : (
          <>
            <h2>Forgot Password</h2>
            <form onSubmit={handleForgotPassword}>
              <motion.input
                type="email"
                placeholder="Enter your email"
                value={forgotEmail}
                onChange={(e) => setForgotEmail(e.target.value)}
                required
                whileFocus={{ scale: 1.02 }}
              />
              {forgotMessage && <p className="info-message">{forgotMessage}</p>}
              <motion.button
                type="submit"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="login-btn"
              >
                Send Reset Link
              </motion.button>
            </form>
            <button
              className="close-btn"
              onClick={() => setShowForgot(false)}
              style={{ marginTop: "10px" }}
            >
              Back to Login
            </button>
          </>
        )}
      </Modal>
    </>
  );
};

export default GetStartedButton;